import classNames from 'clsx';
import styles from '../../embed.style';
import type { VideoEmbedADT } from '../../type';

export function youku(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host === 'v.youku.com') {
    const pathname = input.pathname;
    const id = pathname.match(/\/v_show\/id_(.*)\.html/)?.[1];
    if (!id) return input;
    return (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={`https://player.youku.com/embed/${id}==`}
          width="100%"
          height="100%"
          frameBorder={0}
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  return input;
}
